module.exports = __webpack_public_path__ + "img/timevallee_0.7be72657.jpg";